import { UserMeetingService } from "../meetingService/pages/UserMeetingService"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { UserDailyPurchases } from "../userDailyPurchases/pages/UserDailyPurchases"
import { UserRefillWallet } from "../userRefillWallet/pages/UserRefillWallet"
import { useActiveModules } from "../../../../../shared/hooks/useActiveModules"

export function UserArchiveArchive() {
    const { hasCatering, hasRefillWallet, hasAppPayment } = useActiveModules()
    const { l10n } = useAppLocalization()
    const tabs = []

    if (hasCatering) {
        tabs.push({
            label: l10n.getString("user-archive-drawer-meeting-service"),
            component: <UserMeetingService />,
        })
    }
    if (hasAppPayment) {
        tabs.push({
            label: l10n.getString("user-archive-drawer-daily-purchases"),
            component: <UserDailyPurchases />,
        })
    }
    if (hasRefillWallet) {
        tabs.push({
            label: l10n.getString("user-archive-drawer-refill-wallet"),
            component: <UserRefillWallet />,
        })
    }

    return (
        <>
            <LocalizedStrict id="user-nav-item-archive-title" attrs={{ title: true }}>
                <PageHeader page={Page.USER_ARCHIVE} title="Archive" />
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
